import request from '@/config/axios';

// 3d 模型 VO
export interface Model3dVO {
  id: number; // 编号
  userId: number; // 用户id
  model: string; // 模型
  modelId:string;// 模型编号
  prompt: string; // 提示词
  platform:string; // 平台
  width: number; // 图片宽度
  height: number; // 图片高度
  status: number; // 状态
  publicStatus: boolean; // 公开状态
  applyPublish:boolean;// 申请发布状态
  picUrl: string; // 图片地址
  outputGeneratedImage:string;// 图像地址
  outputRenderedImage:string;// 模型预览地址
  outputPbrModel:string;//pbr 下载地址
  errorMessage: string; // 错误信息
  options:string; //绘制参数
  browseCount:number;//浏览量
  isLike:boolean;//是否点赞
  likeCount:number;//点赞数量
  taskId: number; // 任务编号
  createTime: Date; // 创建时间
  finishTime: Date; // 完成时间
}

// AI 图片 API
export const Model3dApi = {
  // 获取分页
  getList: async (params: any) => {
    return await request.get({ url: `/ai/model3d/page`, params });
  },

  // 详情
  get: async (id: number) => {
    return await request.get({ url: `/ai/model3d/get?id=${id}`});
  },
  
  // 更新绘画发布状态
  update: async (data: any) => {
    return await request.put({ url: '/ai/model3d/update', data });
  },

  // 删除绘画
  delete: async (id: number) => {
    return await request.delete({ url: `/ai/model3d/delete?id=` + id });
  },

  // 发布 
  audits: async (data:{id:Number,publicStatus:Boolean}) => {
    return await request.post({ url: '/ai/model3d/audits-publish',data});
  },

  // 申请发布
  apply: async (data:{id:Number,applyPublish:Boolean}) => {
    return await request.post({ url: '/ai/model3d/apply-publish',data});
  },

  // =================   生成记录============================================
  // 获得所有生成记录分页

};
